import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const UpdateSubDocumentType = MatxLoadable({
    loader: () =>
        import ("./UpdateSubDocumentType")
})
const AllUpdateSubDocumentType= MatxLoadable({
    loader: () =>
        import ("./AllUpdateSubDocumentType")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const UpdateSubDocumentTypeRoutes = [
    {
        path: "/update_sub_document_type",
        component: AllUpdateSubDocumentType,
        // settings
    },

];

export default UpdateSubDocumentTypeRoutes;